/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { RouteCredentail } from '../model/routeCredentail';
import { RouteCredentailResponseDto } from '../model/routeCredentailResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RouteCredentailsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsDelete(id?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiRouteCredentailsDelete(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiRouteCredentailsDelete(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiRouteCredentailsDelete(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/RouteCredentails`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param systemId 
     * @param username 
     * @param routeId 
     * @param callbackUrl 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsDetailGet(id?: string, systemId?: string, username?: string, routeId?: string, callbackUrl?: string, observe?: 'body', reportProgress?: boolean): Observable<RouteCredentail>;
    public apiRouteCredentailsDetailGet(id?: string, systemId?: string, username?: string, routeId?: string, callbackUrl?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCredentail>>;
    public apiRouteCredentailsDetailGet(id?: string, systemId?: string, username?: string, routeId?: string, callbackUrl?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCredentail>>;
    public apiRouteCredentailsDetailGet(id?: string, systemId?: string, username?: string, routeId?: string, callbackUrl?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }
        if (routeId !== undefined && routeId !== null) {
            queryParameters = queryParameters.set('routeId', <any>routeId);
        }
        if (callbackUrl !== undefined && callbackUrl !== null) {
            queryParameters = queryParameters.set('callbackUrl', <any>callbackUrl);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteCredentail>('get',`${this.basePath}/api/RouteCredentails/detail`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param systemId 
     * @param username 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsDetailsGet(systemId?: string, username?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<RouteCredentail>>;
    public apiRouteCredentailsDetailsGet(systemId?: string, username?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RouteCredentail>>>;
    public apiRouteCredentailsDetailsGet(systemId?: string, username?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RouteCredentail>>>;
    public apiRouteCredentailsDetailsGet(systemId?: string, username?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (systemId !== undefined && systemId !== null) {
            queryParameters = queryParameters.set('systemId', <any>systemId);
        }
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RouteCredentail>>('get',`${this.basePath}/api/RouteCredentails/details`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param routeId 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsGetrouteIdAndServiceProviderIdRouteIdServiceProviderIdGet(routeId: string, serviceProviderId: string, observe?: 'body', reportProgress?: boolean): Observable<RouteCredentail>;
    public apiRouteCredentailsGetrouteIdAndServiceProviderIdRouteIdServiceProviderIdGet(routeId: string, serviceProviderId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCredentail>>;
    public apiRouteCredentailsGetrouteIdAndServiceProviderIdRouteIdServiceProviderIdGet(routeId: string, serviceProviderId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCredentail>>;
    public apiRouteCredentailsGetrouteIdAndServiceProviderIdRouteIdServiceProviderIdGet(routeId: string, serviceProviderId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiRouteCredentailsGetrouteIdAndServiceProviderIdRouteIdServiceProviderIdGet.');
        }

        if (serviceProviderId === null || serviceProviderId === undefined) {
            throw new Error('Required parameter serviceProviderId was null or undefined when calling apiRouteCredentailsGetrouteIdAndServiceProviderIdRouteIdServiceProviderIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteCredentail>('get',`${this.basePath}/api/RouteCredentails/GetrouteIdAndServiceProviderId/${encodeURIComponent(String(routeId))}/${encodeURIComponent(String(serviceProviderId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param routeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsGetrouteIdRouteIdGet(routeId: string, observe?: 'body', reportProgress?: boolean): Observable<RouteCredentail>;
    public apiRouteCredentailsGetrouteIdRouteIdGet(routeId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCredentail>>;
    public apiRouteCredentailsGetrouteIdRouteIdGet(routeId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCredentail>>;
    public apiRouteCredentailsGetrouteIdRouteIdGet(routeId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (routeId === null || routeId === undefined) {
            throw new Error('Required parameter routeId was null or undefined when calling apiRouteCredentailsGetrouteIdRouteIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteCredentail>('get',`${this.basePath}/api/RouteCredentails/GetrouteId/${encodeURIComponent(String(routeId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param routeName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsGetrouteNameRouteNameGet(routeName: string, observe?: 'body', reportProgress?: boolean): Observable<RouteCredentail>;
    public apiRouteCredentailsGetrouteNameRouteNameGet(routeName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCredentail>>;
    public apiRouteCredentailsGetrouteNameRouteNameGet(routeName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCredentail>>;
    public apiRouteCredentailsGetrouteNameRouteNameGet(routeName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (routeName === null || routeName === undefined) {
            throw new Error('Required parameter routeName was null or undefined when calling apiRouteCredentailsGetrouteNameRouteNameGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RouteCredentail>('get',`${this.basePath}/api/RouteCredentails/GetrouteName/${encodeURIComponent(String(routeName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsPost(body?: RouteCredentail, observe?: 'body', reportProgress?: boolean): Observable<RouteCredentailResponseDto>;
    public apiRouteCredentailsPost(body?: RouteCredentail, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RouteCredentailResponseDto>>;
    public apiRouteCredentailsPost(body?: RouteCredentail, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RouteCredentailResponseDto>>;
    public apiRouteCredentailsPost(body?: RouteCredentail, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RouteCredentailResponseDto>('post',`${this.basePath}/api/RouteCredentails`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiRouteCredentailsPut(body?: RouteCredentail, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiRouteCredentailsPut(body?: RouteCredentail, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiRouteCredentailsPut(body?: RouteCredentail, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiRouteCredentailsPut(body?: RouteCredentail, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('put',`${this.basePath}/api/RouteCredentails`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
